/** A hidden secret is always this many dots, so the mask does not show how long the secret is. */
export const MASK_DOTS = 12;

/** How long a shown secret stays on the screen before it goes back to dots. */
export const SECRET_SHOWN_MS = 60_000;

export const MASK_TEXT = '•'.repeat(MASK_DOTS);
